import type {ScanContext} from "../scan-model/ScanContext.tsx";
import type {SupportInfoScan} from "../scan-model/ScanResult.tsx";

export async function scanSupportInfo(ctx: ScanContext): Promise<SupportInfoScan> {
    try {
        ctx.log("Scanning support information")
        return ctx.api.supportInfo()
    } catch(e) {
        ctx.logError("Failed to scan support information.", e)
        return {
            failure: "Failed to scan support info"
        }
    }
}